/* Product page — gallery, variant selection, quantity, add to cart, gift card recipient,
   sticky add-to-cart bar, recommendations, recently-viewed tracking. Needs theme.js + cart-drawer.js. */
(function () {
  'use strict';

  function money(cents) {
    return window.A1 && A1.money ? A1.money(cents) : '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Gallery ---------- */
  function initGallery(page) {
    var main = page.querySelector('[data-gallery-main]');
    if (!main) return {};
    var thumbs = Array.prototype.slice.call(page.querySelectorAll('[data-gallery-thumb]'));

    function setActive(thumb) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    function showImage(thumb) {
      var img = document.createElement('img');
      img.src = thumb.getAttribute('data-full');
      img.srcset = thumb.getAttribute('data-srcset') || '';
      img.sizes = '(min-width: 1080px) 50vw, 100vw';
      var timg = thumb.querySelector('img');
      img.alt = timg ? timg.alt : '';
      main.innerHTML = '';
      main.appendChild(img);
      setActive(thumb);
    }
    function showVideo(thumb) {
      var tpl = page.querySelector('[data-video-template="' + thumb.getAttribute('data-video-index') + '"]');
      if (!tpl) return;
      main.innerHTML = '';
      main.appendChild(tpl.content.cloneNode(true));
      setActive(thumb);
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.getAttribute('data-media-type') === 'video') showVideo(thumb);
        else showImage(thumb);
      });
    });
    return {
      showMedia: function (mediaId) {
        var thumb = thumbs.filter(function (t) { return t.getAttribute('data-media-id') === String(mediaId); })[0];
        if (thumb && thumb.getAttribute('data-media-type') === 'image') showImage(thumb);
      }
    };
  }

  /* ---------- Variants ---------- */
  function initVariants(page, gallery, sticky) {
    var variantJson = page.querySelector('[data-variant-json]');
    var variants = variantJson ? JSON.parse(variantJson.textContent) : [];
    var idInput = page.querySelector('[data-variant-id]');
    var priceEl = page.querySelector('[data-product-price]');
    var compareEl = page.querySelector('[data-product-compare]');
    var skuEl = page.querySelector('[data-product-sku]');
    var addBtn = page.querySelector('[data-add-to-cart]');
    var inputs = Array.prototype.slice.call(page.querySelectorAll('[data-option-input]'));

    function selected() {
      var out = [];
      page.querySelectorAll('.variant-picker').forEach(function (fs) {
        var checked = fs.querySelector('[data-option-input]:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function find(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }

    /* Grey out option values that don't exist / are sold out given the other selections */
    function markAvailability(opts) {
      page.querySelectorAll('.variant-picker').forEach(function (fs, idx) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var match = find(test);
          var wrap = input.closest('.variant-option');
          wrap.classList.toggle('is-unavailable', !match);
          wrap.classList.toggle('is-soldout', !!match && !match.available);
        });
      });
    }

    function setButton(state) {
      var labels = {
        add: addBtn.getAttribute('data-label-add'),
        soldout: addBtn.getAttribute('data-label-soldout'),
        unavailable: addBtn.getAttribute('data-label-unavailable')
      };
      addBtn.disabled = state !== 'add';
      addBtn.querySelector('[data-add-label]').textContent = labels[state];
      if (sticky) sticky.setButton(state !== 'add', labels[state]);
    }

    function update(pushUrl) {
      if (!variants.length || !addBtn) return;
      var opts = selected();
      var variant = find(opts);
      markAvailability(opts);

      page.querySelectorAll('[data-option-name]').forEach(function (nameEl) {
        var idx = parseInt(nameEl.getAttribute('data-option-name'), 10);
        nameEl.textContent = opts[idx] || '';
      });

      if (!variant) {
        setButton('unavailable');
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        skuEl.parentElement.hidden = !variant.sku;
      }
      setButton(variant.available ? 'add' : 'soldout');
      if (sticky) sticky.setVariant(variant, money(variant.price));
      if (variant.featured_media && gallery.showMedia) gallery.showMedia(variant.featured_media.id);

      if (pushUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    /* Single-variant products have no pickers: the server-rendered state is already right */
    if (!inputs.length) return;
    inputs.forEach(function (input) {
      input.addEventListener('change', function () { update(true); });
    });
    update(false);
  }

  /* ---------- Quantity ---------- */
  function initQuantity(page) {
    var qtyInput = page.querySelector('[data-qty-input]');
    if (!qtyInput) return;
    page.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qty-btn'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      });
    });
  }

  /* ---------- Gift card recipient ---------- */
  function initGiftRecipient(page) {
    var box = page.querySelector('[data-gift-recipient]');
    if (!box) return;
    var toggle = box.querySelector('[data-gift-recipient-toggle]');
    var fields = box.querySelector('[data-gift-recipient-fields]');
    var offset = box.querySelector('[data-gift-recipient-offset]');
    if (offset) offset.value = new Date().getTimezoneOffset().toString();
    toggle.addEventListener('change', function () {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !toggle.checked; });
      var email = fields.querySelector('input[type="email"]');
      if (email) email.required = toggle.checked;
    });
  }

  /* ---------- Add to cart ---------- */
  function initForm(page) {
    var form = page.querySelector('[data-product-form]');
    var addBtn = page.querySelector('[data-add-to-cart]');
    var errorEl = page.querySelector('[data-product-error]');
    if (!form || !addBtn || !window.A1Cart) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      if (form.checkValidity && !form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (errorEl) errorEl.hidden = true;
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      window.A1Cart.addToCart(new FormData(form))
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message;
            errorEl.hidden = false;
          }
        })
        .then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initSticky(page) {
    var bar = page.querySelector('[data-sticky-atc]');
    var buyRow = page.querySelector('[data-buy-row]');
    if (!bar || !buyRow || !('IntersectionObserver' in window)) return null;
    var btn = bar.querySelector('[data-sticky-button]');
    var label = bar.querySelector('[data-sticky-label]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var variantEl = bar.querySelector('[data-sticky-variant]');
    bar.hidden = false;

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('has-sticky-atc', show);
    }).observe(buyRow);

    return {
      setButton: function (disabled, text) {
        btn.disabled = disabled;
        label.textContent = text;
      },
      setVariant: function (variant, price) {
        priceEl.textContent = price;
        if (variantEl && variant.title !== 'Default Title') variantEl.textContent = variant.title;
      }
    };
  }

  /* ---------- Recommendations (Shopify Search & Discovery) ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (box) {
      var url = box.getAttribute('data-url');
      if (!url || !window.fetch) return;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (!fresh || !fresh.querySelector('[data-product-card]')) return;
          box.innerHTML = fresh.innerHTML;
          box.hidden = false;
        })
        .catch(function () {});
    });
  }

  function init() {
    var page = document.querySelector('[data-product-page]');
    if (!page) return;
    if (window.A1 && A1.recentlyViewed) A1.recentlyViewed.add(page.getAttribute('data-product-handle'));
    var gallery = initGallery(page);
    var sticky = initSticky(page);
    initVariants(page, gallery, sticky);
    initQuantity(page);
    initGiftRecipient(page);
    initForm(page);
    initRecommendations();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
